// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__no7TP","productName":"Table_productName__25lOC"};